/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageViewLogModel } from '../../models/page-view-log-model';

export interface ProfileLogPageAccessPost$Params {
      body?: PageViewLogModel
}

export function profileLogPageAccessPost(http: HttpClient, rootUrl: string, params?: ProfileLogPageAccessPost$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, profileLogPageAccessPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as VitalScoreStrictHttpResponse<boolean>;
    })
  );
}

profileLogPageAccessPost.PATH = '/Profile/LogPageAccess';
